import { Redirect, useHistory } from "react-router-dom";

import { consoleErrorWithSentry } from "../../../utils";
import { deprecatedRoutesMap } from "./maps/deprecatedRoutesMap";

type ParamWithLimits = {
  param: string;
  limits: string[];
};

const findParamsWithLimits = (route: string): ParamWithLimits[] => {
  const routeParamsWithLimits = route.split("/").filter((part) => part.startsWith(":") && part.includes("("));

  return routeParamsWithLimits.map((p) => {
    const parts = p.split("(");
    const param = parts[0].substring(1);
    const limits = parts[1].slice(0, -1).split("|");

    return { param, limits };
  });
};

const replaceRoutePlaceHoldersWithParams = (
  route: string,
  params: Record<string, string>,
  queryString?: string
): string => {
  const limitedParams = findParamsWithLimits(route);
  limitedParams.forEach((pwl) => {
    route = route.replace(`/:${pwl.param}(${pwl.limits.join("|")})`, `/${params[pwl.param]}`);
  });
  Object.keys(params).forEach((p) => {
    route = route.replace(`/:${p}?`, `/${params[p]}`);
    route = route.replace(`/:${p}`, `/${params[p]}`);
  });

  const result = `${route}${queryString ? `?${queryString}` : ""}`;

  // Remove possible trailing '/undefined' parts at the end of the path
  return result.replace(/(\/undefined)+(?=(\?|$))/g, "");
};

const DeprecatedRoutesRedirect = (props) => {
  const history = useHistory();
  const { match } = props;
  const queryString = window.location.href.split("?")[1];
  const newRoute = replaceRoutePlaceHoldersWithParams(deprecatedRoutesMap[match.path], match.params, queryString);

  // log deprecated route access when accessed from somewhere other than email link (login + current page)
  if (history.length > 2) {
    const oldRoute = replaceRoutePlaceHoldersWithParams(match.path, match.params, queryString);
    consoleErrorWithSentry(`Deprecated route accessed: ${oldRoute}`);
  }

  return <Redirect to={newRoute} />;
};

export default DeprecatedRoutesRedirect;
